import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import Collapse from '@mui/material/Collapse';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Tooltip from '@mui/material/Tooltip';
import React, { useState } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { useNavigate } from 'react-router-dom';
import { ISubscriber } from '../../schemas';

export interface ILinkList {
  subscriber: ISubscriber;
}

export default function ProfileLinkList(props: ILinkList) {
  const { subscriber } = props;
  const navigate = useNavigate();
  const [level1, setLevel1] = useState<string | null>(null);
  const [level2, setLevel2] = useState<string | null>(null);
  const [copiedText, setCopiedText] = useState('');
  const days = (size: number): number[] => {
    const _days: number[] = [];
    for (let i: number = 0; i <= size; i++) {
      _days.push(i);
    }
    return _days;
  };

  return (
    <List
      component="nav"
      sx={{
        width: '100%',
        overflow: 'scroll',
        height: 200,
        backgroundColor: (theme) => theme.palette.background.paper
      }}
      dense
    >
      <ListItem button onClick={() => {
        if (level1 === 'programs') {
          setLevel1(null);
        } else {
          setLevel1('programs');
        }
      }}>
        <ListItemText primary="Program Links"/>
        {level1 === 'programs' ? <ExpandLess/> : <ExpandMore/>}
      </ListItem>

      <ListItem button onClick={() => {
        navigate(`/admin/scout/order-creation/${subscriber.uid}`);
      }}>
        <ListItemText primary="User Invoices"/>
      </ListItem>

      <Collapse in={level1 === 'programs'} timeout="auto" unmountOnExit>
        <List component="div" disablePadding dense>
          <ListItem button style={{ marginLeft: 16 }} onClick={() => {
            if (level2 === 'separation-anxiety') {
              setLevel2(null);
            } else {
              setLevel2('separation-anxiety');
            }
          }}>
            <ListItemText primary="Separation Anxiety Links"/>
            {level2 === 'separation-anxiety' ? <ExpandLess/> : <ExpandMore/>}
          </ListItem>
          <Collapse in={level2 === 'separation-anxiety'} timeout="auto" unmountOnExit>

            <List component="div" disablePadding dense>
              {
                days(4).map((day: number) =>
                  <CopyToClipboard
                    text={`www.scout9.com/programs/${subscriber.uid}/separation-anxiety/day${day}-s1`}
                    onCopy={() => setCopiedText(`www.scout9.com/programs/${subscriber.uid}/separation-anxiety/day${day}-s1`)}
                  >
                    <Tooltip
                      title={
                        copiedText === `www.scout9.com/programs/${subscriber.uid}/separation-anxiety/day${day}-s1`
                          ? 'This was Copied!'
                          : 'Copy To Clipboard'
                      }
                      placement="top"
                    >
                      <ListItem button style={{ marginLeft: 32 }}>
                        <ListItemText
                          primary={`Separation Anxiety Day ${day}`}
                          style={{ whiteSpace: 'pre-line' }}
                        />
                      </ListItem>
                    </Tooltip>
                  </CopyToClipboard>
                )
              }
            </List>
          </Collapse>
        </List>
      </Collapse>

    </List>
  );

}
